import { BRAND_KEY, DEFAULT_CURRENCY, LABEL_KEY, SL_SERVER } from './const'
import { LoginProvider } from './LoginProvider'
import Cookies from 'js-cookie'
import { store } from '../redux/store'
import { userSlice, UserInfo, UserSocialProfile } from '../redux/slices/userSlice'
import { Smartico } from './Smartico'
import { walletSlice } from '../redux/slices/walletSlice'

enum CookieNames {
	smCookie = '__smCookie',
}

interface GetBalanceResponse {
	errCode: number;
	errMessage: string;
	amount_real: number;
	amount_bonus: number;
}

class API {
	public static async logout() {
		Cookies.remove(CookieNames.smCookie)

		store.dispatch(userSlice.actions.forgetUser())

		FB.logout()
		API.checkCookieToken()
	}

	public static async checkCookieToken() {
		const cookie_token = Cookies.get(CookieNames.smCookie)
		if (cookie_token) {
			try {
				const r: UserInfo = await API.requestServer('checkCookieToken', { cookie_token })
				if (r && r.user_ext_id) {
					store.dispatch(userSlice.actions.setProfile(r))
					return
				}
			} catch (err) {
				console.error(err)
			}
		}
		store.dispatch(userSlice.actions.setNotLoggedIn())
	}

	public static async duplicateUser() {
		const cookie_token = Cookies.get(CookieNames.smCookie)
		if (cookie_token) {
			await API.requestServer('duplicateUser', { cookie_token })
			await API.checkCookieToken()
			return
		}
		
		// store.dispatch(userSlice.actions.setNotLoggedIn())
	}

	public static async processSocialLogin(provider_id: LoginProvider, provider_user_id: string, provider_token: string, email: string, profile: UserSocialProfile): Promise<boolean> {
		const r = await API.checkSocialToken(provider_id, provider_user_id, provider_token, email, profile)

		if (r.cookie_token) {
			Cookies.set(CookieNames.smCookie, r.cookie_token, { expires: 9999 })
			await API.checkCookieToken()
			return true
		} else {
			return false
		}
	}

	public static async sportBetSlip(data: any): Promise<{ smartico_transaction_id: string; url: string; img: string }> {
		const r = await API.requestServer('temp-register-slip', { data })

		return {
			smartico_transaction_id: r.smartico_transaction_id,
			url: r.url,
			img: SL_SERVER + '/temp-gen-qr/' + encodeURIComponent(r.url),
		}
	}

	public static async sendEventIce(eventName: string, payload: any, user_ext_id: string): Promise<void> {
		return await API.requestServer('sendEventIce', { eventName, payload, user_ext_id })
	}

	public static async checkSocialToken(
		provider_id: LoginProvider,
		provider_user_id: string,
		provider_token: string,
		email: string,
		profile: UserSocialProfile,
	): Promise<{ valid: boolean; cookie_token?: string; user_ext_id?: string }> {
		return API.requestServer('checkProviderToken', {
			provider_id,
			provider_user_id,
			provider_token,
			email,
			profile,
		})
	}

	private static async requestServer(method: string, request: any): Promise<any> {
		const rawResponse = await fetch(SL_SERVER + '/' + method, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				label_public_key: LABEL_KEY,
				brand_public_key: BRAND_KEY,
				...request,
			}),
		})
		return await rawResponse.json()
	}

	public static waitForQR() {
		;(window as Window).addEventListener('message', async (event) => {
			if (event.data) {
				try {
					const obj: any = JSON.parse(event.data)
					if (obj.qr_check) {
						let results = new RegExp('guid=(.*)').exec(obj.url)
						if (results && results.length === 2) {
							const guid = results[1]
							const r = await API.requestServer('temp-resolve-bet-slip', { guid })

							Smartico.lib().event('sport', r.data)
						}
					}
				} catch (e) {}
			}
		})
	}

	public static setUserId(user_id: number) {
		if (!user_id) return

		store.dispatch(userSlice.actions.setUserId(user_id));
	}

	public static async withdraw(amount: number): Promise<boolean> {
		const user_id = store.getState().user.user_id

		if (!user_id || !(amount > 0)) return false

		const response: GetBalanceResponse = await API.requestServer('wallet-debit', {
			user_id,
			currency: DEFAULT_CURRENCY,
			amount_real: amount,
			amount_bonus: 0,
		})

		if (response.amount_real !== undefined && response.amount_bonus !== undefined) {
			store.dispatch(walletSlice.actions.setWalletBalance(response.amount_real))
			store.dispatch(walletSlice.actions.setWalletBonus(response.amount_bonus))
		}

		return response.errCode === 0
	}

	public static setWallet() {
		let t: NodeJS.Timeout;
		const user_id = store.getState().user.user_id;

		if (!user_id) return

		const getBalance = async () => {
			const body = {
				user_id: user_id,
				currency: DEFAULT_CURRENCY,
				amount_real: 0,
				amount_bonus: 0,
			};

			if (user_id !== store.getState().user.user_id) {
				clearInterval(t);
				return;
			}

			try {

				const response: GetBalanceResponse = await API.requestServer('wallet-debit', body);
				//TODO: separate real and bonus balance
				const balance = response.amount_real;
				const bonus = response.amount_bonus;

				if (balance !== undefined && bonus !== undefined) {
					store.dispatch(walletSlice.actions.setWalletBalance(balance));
					store.dispatch(walletSlice.actions.setWalletBonus(bonus));
				}
			} catch(error) {
				console.log('Get wallet balance error:', error);
			}
		};

		t = setInterval(getBalance, 2000);

		getBalance();
	}
}

export { API }
